import Box from '@cloudscape-design/components/box';
import SpaceBetween from '@cloudscape-design/components/space-between';

import DatepickerRange from '../../../../components/DatepickerRange';
import FileUpload from '../../../../components/FileUpload';
import Input from '../../../../components/Input';
import Toggle from '../../../../components/Toggle';

type FormProps = {
  changeImageUrl: (key?: string) => void;
  imageKey?: string;
};

export default function Form({ changeImageUrl, imageKey }: FormProps) {
  return (
    <SpaceBetween size="m">
      <Input name="title" label="Titel" stretch />
      <Input name="location" label="Ort" stretch />
      <DatepickerRange
        label="Datum"
        placeholder="Datum von / bis"
        description="Tag doppelt auswählen wenn es nur einen Tag betrifft."
        name="range"
      />
      <FileUpload changeImageUrl={changeImageUrl} imageKey={imageKey} />
      <Box>
        <SpaceBetween size="s">
          <Toggle
            defaultValue={true}
            label="Aktive"
            description="Soll dieser Eintrag auf der Webseite sichtbar sein."
            name="is_active"
          />
        </SpaceBetween>
      </Box>
    </SpaceBetween>
  );
}
